import useIsFeatureFlagEnabled from './useIsFeatureFlagEnabled';

const useBlockTradesEnabled = () =>
  useIsFeatureFlagEnabled('enableBlockTrades');

export default useBlockTradesEnabled;
